export const events = [
  {
    id: 'xinghe-band-split',
    title: '「星河乐队」主唱深夜长文：十年合作为何走到尽头',
    category: 'music',
    categoryName: '音乐现场',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20recording%20studio%20with%20vintage%20microphone%20and%20warm%20amber%20stage%20lighting%2C%20abstract%20blurred%20bokeh%2C%20cinematic%20editorial%20photography%2C%20dark%20warm%20background%2C%20no%20people%20no%20text&width=800&height=600&seq=chigua-ev-01&orientation=landscape',
    heat: 98200,
    date: '2026-09-08',
    readTime: '4 分钟',
    summary:
      '一条凌晨发布的长文，把成立十年的「星河乐队」推上热搜第一。从巡演票房的分成方式，到新专辑创作权归谁，我们把这段合作里的裂痕按时间摊开。',
    tags: ['乐队变动', '创作分歧', '巡演分成'],
    cause:
      '导火索看起来是一次巡演加场的安排，但根据公开信息，分歧其实早在新专辑筹备期就出现了。主唱希望保留更多现场即兴空间，另外两位成员则倾向把资源集中到录音室版本，双方在创作权重上没能谈拢。',
    process: [
      '首轮巡演结束后，团队内部就加场数量出现不同意见，主唱认为场次过密会影响状态。',
      '新专辑进入编曲阶段，创作署名与版权分成方案被反复提出，但未形成书面共识。',
      '长文发布当晚，话题在短时间内冲上热搜，评论区迅速分裂成两派。',
      '两名成员先后通过经纪人回应，表示愿意当面沟通，同时否认存在「排挤」。',
    ],
    result:
      '截至发稿，乐队尚未宣布正式解散，官方巡演计划维持不变。主唱个人工作室已低调注册，后续是否以个人身份发行作品，仍待时间线继续更新。',
    timeline: [
      {
        date: '08-12',
        title: '巡演加场方案首次提出',
        description: '主办方建议在原有档期基础上增加六场，团队内部就场次密度产生第一次明显分歧。',
        stage: '起点',
      },
      {
        date: '08-24',
        title: '新专辑编曲会不欢而散',
        description: '关于是否保留现场即兴段落的讨论持续了整个下午，最终未能形成统一方案。',
        stage: '发酵',
      },
      {
        date: '09-01',
        title: '版权分成方案被再度提出',
        description: '创作署名问题被摆上桌面，相关人员表示当时已感到「气氛不对」。',
        stage: '发酵',
      },
      {
        date: '09-05',
        title: '主唱缺席一次彩排',
        description: '官方给出的解释是「身体原因」，但时间点与内部讨论高度接近，引发外界猜测。',
        stage: '发酵',
      },
      {
        date: '09-07',
        title: '凌晨长文发布',
        description: '主唱以一段近三千字的自述回顾十年合作，文末写明「想先把话讲清楚」。',
        stage: '回应',
      },
      {
        date: '09-08',
        title: '两名成员回应',
        description: '成员通过经纪人表示愿意当面沟通，明确否认存在排挤，呼吁给团队一点时间。',
        stage: '结局',
      },
    ],
    related: ['lin-wanqing-concert', 'bubblegum-member-exit', 'screenplay-three-scripts'],
    featured: true,
    trend: 'rising',
  },
  {
    id: 'changan-du-recast',
    title: '古装剧《长安渡》临阵换角风波全复盘',
    category: 'screen',
    categoryName: '影视综',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20corridor%20in%20warm%20cinematic%20light%2C%20ornate%20red%20pillars%20and%20silk%20lanterns%2C%20period%20drama%20film%20still%20aesthetic%2C%20soft%20haze%2C%20no%20people%20no%20text&width=800&height=600&seq=chigua-ev-02&orientation=landscape',
    heat: 87600,
    date: '2026-09-06',
    readTime: '5 分钟',
    summary:
      '开机前二十天，《长安渡》把已经官宣的男主角换掉。从合同条款到档期冲突，剪辑预告到溜粉争议，这场换角牵扯出的问题比想象中多。',
    tags: ['换角', '档期冲突', '官宣物料'],
    cause:
      '片方给出的公开理由是「档期无法匹配」，但多位剧组成员透露，真正的分歧集中在角色定位与拍摄周期上。原定演员希望保留人物前史的完整线，片方则因为拍摄进度压缩，选择简化这条线。',
    process: [
      '官宣海报与概念预告先后发布，演员造型话题一度登上热搜。',
      '开机前剧本进行了一轮调整，主要人物的前史段落被大幅压缩。',
      '演员方与片方就修改幅度进行沟通，未能达成一致。',
      '片方宣布更换男主角，并已发布的新物料被陆续下架。',
    ],
    result:
      '目前剧组已重新开机，新主演进组并完成定妆。原演员方未再公开回应，只保留了官宣微博。换角导致的进度延后约两周，播出平台排期暂未调整。',
    timeline: [
      {
        date: '06-18',
        title: '官宣主演阵容',
        description: '片方发布概念海报，男主角人选正式公布，相关话题当晚进入热搜前列。',
        stage: '起点',
      },
      {
        date: '07-02',
        title: '首支造型预告上线',
        description: '预告片放出后造型讨论度很高，观众普遍认可，期待值被拉高。',
        stage: '发酵',
      },
      {
        date: '08-10',
        title: '剧本进入一轮调整',
        description: '因拍摄周期压缩，主要人物的前史线索被简化，涉及多个场次的重写。',
        stage: '发酵',
      },
      {
        date: '08-22',
        title: '双方就修改幅度沟通',
        description: '演员方希望在核心人物线上保留完整表达，沟通持续多日未果。',
        stage: '发酵',
      },
      {
        date: '09-03',
        title: '换角消息流出',
        description: '剧组内部消息被传至社交平台，相关词条迅速升温，片方暂未回应。',
        stage: '回应',
      },
      {
        date: '09-06',
        title: '片方正式说明',
        description: '以「档期无法匹配」为由确认换角，已发布的造型物料被下架，新主演随后进组。',
        stage: '结局',
      },
    ],
    related: ['wugang-ending-change', 'wildkitchen-editing', 'screenplay-three-scripts'],
    featured: true,
    trend: 'steady',
  },
  {
    id: 'lin-wanqing-concert',
    title: '歌手林晚晴演唱会加场争议始末',
    category: 'music',
    categoryName: '音乐现场',
    cover:
      'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20warm%20spotlights%20and%20glowing%20haze%2C%20empty%20arena%20seats%2C%20dramatic%20amber%20and%20red%20lighting%2C%20cinematic%20wide%20shot%2C%20no%20people%20no%20text&width=800&height=600&seq=chigua-ev-03&orientation=landscape',
    heat: 76400,
    date: '2026-09-04',
    readTime: '4 分钟',
    summary:
      '首轮开票三分钟售罄，随后宣布加开四场。可新场次的座位分区与退改规则，引发了持续一周的讨论，我们把每一步都写进时间线。',
    tags: ['演唱会', '加场', '票务规则'],
    cause:
      '争议的起点并非加场本身，而是加场后的座位图与首轮存在差异。部分购买了首轮看台票的观众发现，新场次同一区域的视角更优，价格却相近，由此产生「买早吃亏」的感受。',
    process: [
      '首轮开票三分钟售罄，主办方随即预告「正在协调加场」。',
      '加场四场官宣，但座位分区图与首轮并不一致，差价问题被提出。',
      '有观众在社交平台整理出两轮座位图对比，讨论迅速扩散。',
      '主办方补充说明退改规则，并开放一次免费调换窗口。',
    ],
    result:
      '加场门票在开放调换后基本消化，票务页面更新了完整的分区示意图。主办方承诺后续场次将统一座位标注口径，目前暂无进一步的补偿方案公布。',
    timeline: [
      {
        date: '08-15',
        title: '首轮开票三分钟售罄',
        description: '多个价位的门票瞬间售空，官方预告正在协调加开场次。',
        stage: '起点',
      },
      {
        date: '08-20',
        title: '加场四场正式官宣',
        description: '加场消息公布，同时放出新场次座位分区图，与首轮存在细微差异。',
        stage: '发酵',
      },
      {
        date: '08-25',
        title: '座位图对比贴流传',
        description: '有观众整理两轮分区图，指出同价位视角差异，贴文被大量转发。',
        stage: '发酵',
      },
      {
        date: '08-29',
        title: '话题登上热搜',
        description: '「买早吃亏」的讨论集中爆发，主办方评论区被追问票务规则。',
        stage: '发酵',
      },
      {
        date: '09-02',
        title: '主办方补充说明',
        description: '公开退改规则细节，并开放一次免费调换窗口，承认座位标注存在口径不一。',
        stage: '回应',
      },
      {
        date: '09-04',
        title: '调换窗口关闭',
        description: '加场门票基本消化，票务页更新完整分区示意图，事件暂时平息。',
        stage: '结局',
      },
    ],
    related: ['xinghe-band-split', 'bubblegum-member-exit'],
    featured: true,
    trend: 'cooling',
  },
  {
    id: 'wildkitchen-editing',
    title: '综艺《野生厨房》剪辑争议：观众为何集体破防',
    category: 'screen',
    categoryName: '影视综',
    cover:
      'https://readdy.ai/api/search-image?query=Rustic%20outdoor%20kitchen%20set%20with%20cast%20iron%20pots%20and%20warm%20campfire%20glow%20at%20dusk%2C%20cinematic%20food%20variety%20show%20still%2C%20warm%20earthy%20tones%2C%20no%20people%20no%20text&width=800&height=600&seq=chigua-ev-04&orientation=landscape',
    heat: 64100,
    date: '2026-09-02',
    readTime: '3 分钟',
    summary:
      '第四期播出后，「恶意剪辑」的质疑刷屏。把嘉宾的原话、成片的顺序和场记单放在一起比对，问题出在哪个环节，其实有迹可循。',
    tags: ['综艺剪辑', '嘉宾回应', '场记单'],
    cause:
      '争议源于成片对两段素材的顺序进行了调整，导致同一句回应被放在了不同的语境里。观众在原片花絮中看到了时间顺序不同的版本，落差感由此产生。',
    process: [
      '第四期播出当晚，有观众在花絮中发现素材顺序与正片不一致。',
      '对比视频被整理上传，评论区集中质疑剪辑制造冲突。',
      '节目组发布声明，说明是为了「控制单集时长」做出的取舍。',
      '嘉宾本人发文回应，表示录制现场并未发生正片呈现的争执。',
    ],
    result:
      '节目组承诺后续期数会保留更多完整过程，并在片尾补充说明。第五期播出后争议明显降温，但「剪辑透明」的讨论仍在持续。',
    timeline: [
      {
        date: '08-14',
        title: '第四期上线',
        description: '节目正片播出，其中一段嘉宾互动被呈现为明显的意见对立。',
        stage: '起点',
      },
      {
        date: '08-15',
        title: '花絮暴露顺序差异',
        description: '细心观众发现同一句回应在花絮与正片中的前后语境并不相同。',
        stage: '发酵',
      },
      {
        date: '08-17',
        title: '对比视频冲上热搜',
        description: '剪辑对比内容被大量转发，「恶意剪辑」成为讨论核心词。',
        stage: '发酵',
      },
      {
        date: '08-19',
        title: '节目组发布声明',
        description: '解释调整顺序是为了控制单集时长，否认刻意制造冲突。',
        stage: '回应',
      },
      {
        date: '08-21',
        title: '嘉宾本人回应',
        description: '嘉宾表示录制现场气氛平和，希望大家关注节目本身的内容。',
        stage: '回应',
      },
      {
        date: '08-28',
        title: '第五期调整呈现方式',
        description: '新一期保留更多完整过程，片尾补充说明，争议逐渐降温。',
        stage: '结局',
      },
    ],
    related: ['changan-du-recast', 'wugang-ending-change'],
    trend: 'cooling',
  },
  {
    id: 'shen-yizhou-endorsement',
    title: '演员沈亦舟代言解约事件完整时间线',
    category: 'brand',
    categoryName: '品牌代言',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20product%20podium%20with%20soft%20warm%20spotlight%20and%20brick%20red%20drapery%2C%20luxury%20brand%20commercial%20set%2C%20minimal%20abstract%2C%20no%20text%20no%20people&width=800&height=600&seq=chigua-ev-05&orientation=landscape',
    heat: 58900,
    date: '2026-08-30',
    readTime: '4 分钟',
    summary:
      '从官宣到解约只隔了四十天。品牌方与艺人团队各自的表述都不算长，但把双方声明的时间点排在一起，就能看出分歧究竟卡在哪。',
    tags: ['代言解约', '物料下架', '商业合作'],
    cause:
      '合作初期推进顺利，分歧出现在一支线下广告的拍摄方案上。方案涉及的角色形象与艺人团队此前对外的定位并不完全一致，双方对「可接受范围」的理解出现偏差。',
    process: [
      '品牌官宣代言，同步上线一组平面物料，传播数据表现良好。',
      '线下广告进入拍摄筹备，创意方案与艺人既定形象产生出入。',
      '双方就方案调整进行沟通，多次修改后仍未达成一致。',
      '品牌方发布简短说明，宣布双方终止合作，相关物料陆续下架。',
    ],
    result:
      '所有已投放的线上物料在两天内完成替换，线下广告位同步撤换。双方均表示不再就此事发表进一步说明，代言费用与违约条款如何处理未对外披露。',
    timeline: [
      {
        date: '07-18',
        title: '品牌官宣代言',
        description: '首组平面物料同步上线，相关话题阅读量表现亮眼。',
        stage: '起点',
      },
      {
        date: '08-05',
        title: '线下广告进入筹备',
        description: '创意方案初步定稿，涉及的角色设定与艺人既定形象存在差异。',
        stage: '发酵',
      },
      {
        date: '08-14',
        title: '方案沟通陷入僵局',
        description: '双方就核心设定反复修改，多轮沟通后仍未取得一致。',
        stage: '发酵',
      },
      {
        date: '08-26',
        title: '合作终止消息流出',
        description: '有行业账号率先披露解约，双方团队均未第一时间回应。',
        stage: '发酵',
      },
      {
        date: '08-28',
        title: '品牌方发布说明',
        description: '以简短声明宣布终止合作，未披露具体原因，相关物料开始下架。',
        stage: '回应',
      },
      {
        date: '08-30',
        title: '线上物料替换完成',
        description: '两天内完成全部投放内容替换，双方均表示不再进一步说明。',
        stage: '结局',
      },
    ],
    related: ['screenplay-three-scripts', 'changan-du-recast'],
    trend: 'steady',
  },
  {
    id: 'screenplay-three-scripts',
    title: '编剧实名爆料：一部剧的三个剧本之谜',
    category: 'backstage',
    categoryName: '幕后揭秘',
    cover:
      'https://readdy.ai/api/search-image?query=Stack%20of%20screenplay%20pages%20and%20vintage%20typewriter%20on%20wooden%20desk%20with%20warm%20lamp%20light%2C%20moody%20writer%20studio%2C%20cinematic%20close%20up%2C%20no%20people%20no%20text&width=800&height=600&seq=chigua-ev-06&orientation=landscape',
    heat: 51200,
    date: '2026-08-27',
    readTime: '5 分钟',
    summary:
      '一部已杀青的剧，前后出现过三版结构完全不同的剧本。编剧的实名长文让「剧本工厂」的话题重新被讨论，我们把三版之间的关系理了一遍。',
    tags: ['剧本', '署名权', '行业观察'],
    cause:
      '长文的核心诉求是署名与稿酬。编剧表示自己完成了第一版完整剧本，后续两版由不同团队接力改写，但自己的名字只出现在了最早的报备材料里。',
    process: [
      '编剧完成第一版剧本，并参与前期剧本会，署名进入报备材料。',
      '项目调整方向，第二版剧本由另一团队重写，结构大幅变化。',
      '拍摄阶段又出现第三版，主要服务于演员档期与场地限制。',
      '剧目杀青后，编剧发布实名长文，提出署名与稿酬诉求。',
    ],
    result:
      '制作方回应称「三版均属正常创作迭代」，并表示署名将按合同执行。编剧方称已委托律师沟通，事件目前仍在协商阶段，暂未进入公开调解。',
    timeline: [
      {
        date: '04-09',
        title: '第一版剧本完成',
        description: '编剧完成完整剧本并参与前期剧本会，署名进入项目报备材料。',
        stage: '起点',
      },
      {
        date: '05-22',
        title: '项目方向调整',
        description: '因题材与市场判断变化，第二版剧本由另一团队接手重写。',
        stage: '发酵',
      },
      {
        date: '07-03',
        title: '第三版剧本出现',
        description: '为适配演员档期与拍摄场地，剧本结构再次大幅调整用于实拍。',
        stage: '发酵',
      },
      {
        date: '08-20',
        title: '编剧发布实名长文',
        description: '公开三版剧本的存在，提出署名与稿酬方面的具体诉求。',
        stage: '回应',
      },
      {
        date: '08-24',
        title: '制作方回应',
        description: '表示三版均属正常创作迭代，署名问题将按合同条款执行。',
        stage: '回应',
      },
      {
        date: '08-27',
        title: '进入协商阶段',
        description: '编剧方称已委托律师沟通，双方尚未就署名方案达成一致。',
        stage: '结局',
      },
    ],
    related: ['xinghe-band-split', 'shen-yizhou-endorsement', 'changan-du-recast'],
    trend: 'steady',
  },
  {
    id: 'bubblegum-member-exit',
    title: '女团「泡泡糖」成员退出：合约、分成与沉默期',
    category: 'star',
    categoryName: '明星动向',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20rehearsal%20room%20with%20mirrored%20wall%20and%20warm%20stage%20lighting%2C%20pop%20idol%20training%20studio%2C%20soft%20haze%2C%20cinematic%2C%20no%20people%20no%20text&width=800&height=600&seq=chigua-ev-07&orientation=landscape',
    heat: 47300,
    date: '2026-08-24',
    readTime: '4 分钟',
    summary:
      '官方口径是「个人发展原因」，但粉丝注意到组合近三个月的物料里，这位成员出现的次数明显减少。时间线里藏着比声明更具体的线索。',
    tags: ['团体变动', '合约', '分成'],
    cause:
      '从公开物料看，变化的起点是一次音乐节阵容调整。该成员临时缺席后，之后的团体活动里她的镜头与站位都发生了变化，这让长期关注组合的粉丝最早察觉异常。',
    process: [
      '音乐节阵容临时调整，该成员缺席，官方解释为行程冲突。',
      '随后三支团体物料中，其镜头与站位明显减少。',
      '粉丝在社交平台整理物料对比，讨论热度逐步上升。',
      '公司在合约到期日当天发布声明，宣布该成员不再续约。',
    ],
    result:
      '组合已按六人阵容继续活动，官方未公布后续补位计划。该成员个人社交账号恢复更新，但未就合约细节做任何说明，分成安排仍不明确。',
    timeline: [
      {
        date: '05-30',
        title: '音乐节阵容临时调整',
        description: '该成员缺席既定演出，官方解释为行程冲突，未做进一步说明。',
        stage: '起点',
      },
      {
        date: '06-21',
        title: '团体物料镜头减少',
        description: '新发布的三支物料中，其站位与镜头时长较此前明显减少。',
        stage: '发酵',
      },
      {
        date: '07-15',
        title: '粉丝整理物料对比',
        description: '对比内容在社交平台流传，「是否要退团」的讨论持续升温。',
        stage: '发酵',
      },
      {
        date: '08-10',
        title: '合约到期日临近',
        description: '公司未按惯例发布续约预告，外界猜测进一步集中。',
        stage: '发酵',
      },
      {
        date: '08-22',
        title: '公司发布声明',
        description: '宣布该成员因个人发展不再续约，感谢其过去几年的付出。',
        stage: '回应',
      },
      {
        date: '08-24',
        title: '组合以六人阵容活动',
        description: '官方未公布补位计划，该成员恢复个人账号更新，未谈及分成细节。',
        stage: '结局',
      },
    ],
    related: ['xinghe-band-split', 'lin-wanqing-concert'],
    trend: 'cooling',
  },
  {
    id: 'wugang-ending-change',
    title: '剧集《雾港》结局改档：平台、片方与观众的三角博弈',
    category: 'screen',
    categoryName: '影视综',
    cover:
      'https://readdy.ai/api/search-image?query=Foggy%20harbor%20at%20night%20with%20warm%20street%20lamps%20and%20silhouetted%20pier%2C%20cinematic%20noir%20film%20still%2C%20deep%20teal%20and%20amber%20tones%2C%20no%20people%20no%20text&width=800&height=600&seq=chigua-ev-08&orientation=landscape',
    heat: 43800,
    date: '2026-08-20',
    readTime: '4 分钟',
    summary:
      '大结局播出一周后被悄悄替换，新版本的结尾与旧版在关键情节上完全不同。观众手里的截图成了最直接的证据，我们把两个版本的差异梳理清楚。',
    tags: ['结局改档', '版本差异', '平台排期'],
    cause:
      '改档的直接原因是平台收到了大量关于结局逻辑的反馈。但根据公开信息，制作方原本就在准备另一版结尾，只是没有确定播出时间，这次争议加速了决定。',
    process: [
      '大结局按时播出，结尾的关键情节引发观众集中讨论。',
      '相关话题连续两天占据讨论榜，逻辑漏洞被逐条指出。',
      '播出平台将剧集短暂下架，页面显示「内容调整中」。',
      '重新上线的版本更换了结尾部分，新增了约八分钟内容。',
    ],
    result:
      '新版结局上线后，讨论分成「更完整」与「改了就不是原文」两种声音。片方未回应是否推出导演剪辑版，平台的排期页也未标注版本差异。',
    timeline: [
      {
        date: '07-28',
        title: '大结局正常播出',
        description: '结尾的关键情节处理引发观众讨论，相关话题进入榜单。',
        stage: '起点',
      },
      {
        date: '07-29',
        title: '逻辑争议集中爆发',
        description: '观众逐条指出情节衔接问题，相关讨论连续两天维持高位。',
        stage: '发酵',
      },
      {
        date: '08-02',
        title: '剧集短暂下架',
        description: '平台页面显示「内容调整中」，剧集从可播放列表移除。',
        stage: '发酵',
      },
      {
        date: '08-05',
        title: '新版结局上线',
        description: '重新上线的版本更换结尾并新增约八分钟内容，新旧片段被大量对比。',
        stage: '回应',
      },
      {
        date: '08-12',
        title: '讨论出现分歧',
        description: '观众分成支持修改与保留原版两派，片方未就版本问题作出说明。',
        stage: '回应',
      },
      {
        date: '08-20',
        title: '事件暂告段落',
        description: '平台排期页未标注版本差异，导演剪辑版是否推出仍无消息。',
        stage: '结局',
      },
    ],
    related: ['changan-du-recast', 'wildkitchen-editing'],
    trend: 'cooling',
  },
];

export const hotTags = [
  '星河乐队',
  '长安渡换角',
  '林晚晴加场',
  '剧本工厂',
  '泡泡糖退团',
  '雾港结局',
];